import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LetterRequestCustomer_Cancel,Empty_LetterRequestCustomer_Cancel } from 'src/app/Interface/LetterRequestCustomer_Cancel';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LetterRequestCustomerScheduleCancel',
  templateUrl: './LetterRequestCustomerScheduleCancel.component.html',
  styleUrls: ['./LetterRequestCustomerScheduleCancel.component.scss']
})
export class LetterRequestCustomerScheduleCancelComponent implements OnInit {

  Token:String=""
  Filter_Letter:string="0"
  Filter_Dsc:string=""

  Procssing:boolean=false

  modalRef_Cancel: any;

  constructor(
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Schedules:Array<LetterRequestCustomer_Cancel>=[]
  DataList_SchedulesUser: Array<LetterRequestCustomer_Cancel> = []
  DataList_SchedulesUser_Record: LetterRequestCustomer_Cancel =Empty_LetterRequestCustomer_Cancel()

  Data_Seleted_Cancel:LetterRequestCustomer_Cancel=Empty_LetterRequestCustomer_Cancel()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1126).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Schedules(){
    this.Procssing=true

    this.LetterRequestCustomer_Service.GetActiveMissionByLetter(this.Token,Number(this.Filter_Letter),0).subscribe(
      data=>{
        this.DataList_Schedules=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_SchedulesUser(){
    this.InProccessing_SchedulesUser=true

    this.LetterRequestCustomer_Service.GetActiveMissionByLetterCancelUser(this.Token,Number(this.Filter_Letter),0).subscribe(
      data=>{
        this.DataList_SchedulesUser=data
        this.InProccessing_SchedulesUser=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Cancel(item:LetterRequestCustomer_Cancel){
    item.DeletingProccess=true
    this.modalRef_Cancel.hide()
    this.LetterRequestCustomer_Service.PostCancelMission(item.id,this.Filter_Dsc,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("The assignment was cancelled.")
        this.ReadData_Schedules()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Cancel=Record
    this.Filter_Dsc=''
    this.modalRef_Cancel = this.modalService.show(template);
  }

  InProccessing_SchedulesUser:boolean=false
  Data_Seleted_Delete_Status: number = 0
  OperationDsc_CancelScheduleRequest:string=''
  modalRef_CancelScheduleRequest
  openModalCancelScheduleRequest(template: TemplateRef<any>,Record:LetterRequestCustomer_Cancel,Status:number) {
    this.DataList_SchedulesUser_Record = Record
    this.OperationDsc_CancelScheduleRequest=""
    this.Data_Seleted_Delete_Status = Status
    this.modalRef_CancelScheduleRequest = this.modalService.show(template);
  }

  Answer_CancelScheduleRequest(){
    this.InProccessing_SchedulesUser=true
    this.modalRef_CancelScheduleRequest.hide()
    this.LetterRequestCustomer_Service.Answer_CancelScheduleRequest(Number(this.DataList_SchedulesUser_Record.code2),
      this.Data_Seleted_Delete_Status,
      this.Token,
      this.OperationDsc_CancelScheduleRequest).subscribe(
      data=>{
        this.InProccessing_SchedulesUser = false

        this.ReadData_SchedulesUser()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
